import { render } from "./SingleCursoCombo.vue?vue&type=template&id=4a36cf8e&scoped=true"
import script from "./SingleCursoCombo.vue?vue&type=script&lang=js"
export * from "./SingleCursoCombo.vue?vue&type=script&lang=js"

import "./SingleCursoCombo.vue?vue&type=style&index=0&id=4a36cf8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a36cf8e"]])

export default __exports__